import { createApiAction } from 'src/api';

export const FETCH_SCHEDULED_TASKS_START = 'fis/fetch_scheduled_tasks_start';
export const FETCH_SCHEDULED_TASKS_SUCCESS =
  'fis/fetch_scheduled_tasks_success';
export const FETCH_SCHEDULED_TASKS_FAILURE =
  'fis/fetch_scheduled_tasks_failure';

export const ADD_SCHEDULED_TASKS_START = 'fis/add_scheduled_tasks_start';
export const ADD_SCHEDULED_TASKS_SUCCESS = 'fis/add_scheduled_tasks_success';
export const ADD_SCHEDULED_TASKS_FAILURE = 'fis/add_scheduled_tasks_failure';

export const UPDATE_SCHEDULED_TASK_START = 'fis/update_scheduled_tasks_start';
export const UPDATE_SCHEDULED_TASK_SUCCESS =
  'fis/update_scheduled_tasks_success';
export const UPDATE_SCHEDULED_TASK_FAILURE =
  'fis/update_scheduled_tasks_failure';

export const DELETE_SCHEDULED_TASK_START = 'fis/delete_scheduled_tasks_start';
export const DELETE_SCHEDULED_TASK_SUCCESS =
  'fis/delete_scheduled_tasks_success';
export const DELETE_SCHEDULED_TASK_FAILURE =
  'fis/delete_scheduled_tasks_failure';

export const fetchTasks = fi =>
  createApiAction(
    {
      path: `/api/v1/fis/${fi}/scheduled_tasks`,
      method: 'GET',
    },
    [
      FETCH_SCHEDULED_TASKS_START,
      FETCH_SCHEDULED_TASKS_SUCCESS,
      FETCH_SCHEDULED_TASKS_FAILURE,
    ]
  );

export const addAccountTask = ({
  fi,
  taskEmail,
  taskTypeId,
  taskFrequencyId,
  taskLastStart,
  taskId,
}) =>
  createApiAction(
    {
      path: `/api/v1/fis/${fi}/scheduled_tasks/`,
      method: 'POST',
      body: {
        engine_task_fi_id: fi,
        engine_task_email: taskEmail,
        engine_task_type_id: taskTypeId,
        engine_task_frequency_id: taskFrequencyId,
        engine_task_last_start: taskLastStart,
        engine_task_scheduler_id_id: taskId,
      },
    },
    [
      ADD_SCHEDULED_TASKS_START,
      ADD_SCHEDULED_TASKS_SUCCESS,
      ADD_SCHEDULED_TASKS_FAILURE,
    ]
  );

export const updateAccountTask = ({
  fi,
  taskEmail,
  taskTypeId,
  taskFrequencyId,
  taskLastStart,
  taskId,
}) =>
  createApiAction(
    {
      path: `/api/v1/fis/${fi}/scheduled_tasks/${taskId}/`,
      method: 'PUT',
      body: {
        engine_task_fi_id: fi,
        engine_task_email: taskEmail,
        engine_task_type_id: taskTypeId,
        engine_task_frequency_id: taskFrequencyId,
        engine_task_last_start: taskLastStart,
        engine_task_scheduler_id_id: taskId,
      },
    },
    [
      UPDATE_SCHEDULED_TASK_START,
      UPDATE_SCHEDULED_TASK_SUCCESS,
      UPDATE_SCHEDULED_TASK_FAILURE,
    ]
  );

export const deleteAccountTask = ({ fi, taskId }) =>
  createApiAction(
    {
      path: `/api/v1/fis/${fi}/scheduled_tasks/${taskId}/`,
      method: 'DELETE',
    },
    [
      DELETE_SCHEDULED_TASK_START,
      DELETE_SCHEDULED_TASK_SUCCESS,
      DELETE_SCHEDULED_TASK_FAILURE,
    ]
  );
